<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  {{data.message}}
</div>
<div style="float:right;margin:20px;">
  <input style="margin:0px 10px;" type="button" value="{{data.buttonYes}}" [mat-dialog-close]="true">
  <input type="button" value="{{data.buttonNo}}"  [mat-dialog-close]="false">
</div>
